var map = {
	"./ion-action-sheet-controller_8.entry.js": [
		15346,
		5346
	],
	"./ion-action-sheet-ios.entry.js": [
		73632,
		128,
		7637
	],
	"./ion-action-sheet-md.entry.js": [
		11988,
		128,
		1119
	],
	"./ion-alert-ios.entry.js": [
		3872,
		128,
		1755
	],
	"./ion-alert-md.entry.js": [
		4980,
		128,
		4569
	],
	"./ion-app_8-ios.entry.js": [
		60514,
		514
	],
	"./ion-app_8-md.entry.js": [
		71602,
		1602
	],
	"./ion-avatar_3-ios.entry.js": [
		62855,
		2855
	],
	"./ion-avatar_3-md.entry.js": [
		6469,
		6469
	],
	"./ion-back-button-ios.entry.js": [
		59000,
		9000
	],
	"./ion-back-button-md.entry.js": [
		82796,
		2796
	],
	"./ion-backdrop-ios.entry.js": [
		97966,
		7966
	],
	"./ion-backdrop-md.entry.js": [
		34814,
		4814
	],
	"./ion-button_2-ios.entry.js": [
		93473,
		3473
	],
	"./ion-button_2-md.entry.js": [
		87899,
		7899
	],
	"./ion-card_5-ios.entry.js": [
		57310,
		7310
	],
	"./ion-card_5-md.entry.js": [
		60718,
		718
	],
	"./ion-checkbox-ios.entry.js": [
		91025,
		1025
	],
	"./ion-checkbox-md.entry.js": [
		99243,
		9243
	],
	"./ion-chip-ios.entry.js": [
		39174,
		9174
	],
	"./ion-chip-md.entry.js": [
		97270,
		7270
	],
	"./ion-col_3.entry.js": [
		79130,
		9130
	],
	"./ion-datetime_3-ios.entry.js": [
		1971,
		128,
		1971
	],
	"./ion-datetime_3-md.entry.js": [
		81713,
		128,
		1713
	],
	"./ion-fab_3-ios.entry.js": [
		70721,
		721
	],
	"./ion-fab_3-md.entry.js": [
		90555,
		555
	],
	"./ion-img.entry.js": [
		59598,
		7217
	],
	"./ion-infinite-scroll_2-ios.entry.js": [
		34025,
		4025
	],
	"./ion-infinite-scroll_2-md.entry.js": [
		14691,
		4691
	],
	"./ion-input-ios.entry.js": [
		57226,
		7226
	],
	"./ion-input-md.entry.js": [
		13082,
		3082
	],
	"./ion-item-option_3-ios.entry.js": [
		52363,
		2363
	],
	"./ion-item-option_3-md.entry.js": [
		2569,
		2569
	],
	"./ion-item_8-ios.entry.js": [
		58560,
		8560
	],
	"./ion-item_8-md.entry.js": [
		7764,
		7764
	],
	"./ion-loading-ios.entry.js": [
		23022,
		128,
		9473
	],
	"./ion-loading-md.entry.js": [
		94142,
		128,
		7387
	],
	"./ion-menu_4-ios.entry.js": [
		83000,
		128,
		6257,
		3000
	],
	"./ion-menu_4-md.entry.js": [
		42924,
		128,
		6257,
		2924
	],
	"./ion-modal-ios.entry.js": [
		27391,
		128,
		5092
	],
	"./ion-modal-md.entry.js": [
		72573,
		128,
		4024
	],
	"./ion-nav_5.entry.js": [
		67779,
		7779
	],
	"./ion-popover-ios.entry.js": [
		53171,
		128,
		8672
	],
	"./ion-popover-md.entry.js": [
		53489,
		128,
		3076
	],
	"./ion-progress-bar-ios.entry.js": [
		10151,
		151
	],
	"./ion-progress-bar-md.entry.js": [
		41861,
		1861
	],
	"./ion-radio_2-ios.entry.js": [
		30224,
		224
	],
	"./ion-radio_2-md.entry.js": [
		22532,
		2532
	],
	"./ion-range-ios.entry.js": [
		27539,
		7539
	],
	"./ion-range-md.entry.js": [
		96273,
		6273
	],
	"./ion-refresher_2-ios.entry.js": [
		73987,
		3987
	],
	"./ion-refresher_2-md.entry.js": [
		66753,
		6753
	],
	"./ion-reorder_2-ios.entry.js": [
		27524,
		7524
	],
	"./ion-reorder_2-md.entry.js": [
		11800,
		1800
	],
	"./ion-ripple-effect.entry.js": [
		79002,
		9002
	],
	"./ion-route_4.entry.js": [
		21580,
		1580
	],
	"./ion-searchbar-ios.entry.js": [
		75599,
		5599
	],
	"./ion-searchbar-md.entry.js": [
		5453,
		5453
	],
	"./ion-segment_2-ios.entry.js": [
		13722,
		3722
	],
	"./ion-segment_2-md.entry.js": [
		458,
		458
	],
	"./ion-select_3-ios.entry.js": [
		32046,
		2046
	],
	"./ion-select_3-md.entry.js": [
		16606,
		6606
	],
	"./ion-slide_2-ios.entry.js": [
		22642,
		2642
	],
	"./ion-slide_2-md.entry.js": [
		79170,
		6789
	],
	"./ion-spinner.entry.js": [
		88155,
		8155
	],
	"./ion-split-pane-ios.entry.js": [
		96493,
		6493
	],
	"./ion-split-pane-md.entry.js": [
		67607,
		7607
	],
	"./ion-tab-bar_2-ios.entry.js": [
		80648,
		648
	],
	"./ion-tab-bar_2-md.entry.js": [
		11100,
		1100
	],
	"./ion-tab_2.entry.js": [
		38384,
		8384
	],
	"./ion-text.entry.js": [
		93883,
		3883
	],
	"./ion-textarea-ios.entry.js": [
		32490,
		2490
	],
	"./ion-textarea-md.entry.js": [
		72890,
		2890
	],
	"./ion-toast-ios.entry.js": [
		10857,
		128,
		6986
	],
	"./ion-toast-md.entry.js": [
		64291,
		128,
		5674
	],
	"./ion-toggle-ios.entry.js": [
		43556,
		3556
	],
	"./ion-toggle-md.entry.js": [
		76920,
		6920
	],
	"./ion-virtual-scroll.entry.js": [
		1159,
		1159
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 2179;
module.exports = webpackAsyncContext;